import * as appConfig from './../../app.config';

export class DataUtils {
  private static _limit = 80;

  public static getTitle(titleObject: any): string {
    let title = '';
    if (titleObject) {
      if (titleObject.title) {
        return titleObject.title;
      }
      appConfig.languages.some(lang => {
        if (titleObject['title_' + lang]) {
          title = titleObject['title_' + lang];
          return true;
        }
      });
      if (!title) {
        appConfig.languages.some(lang => {
          const temp = document.createElement('DIV');
          temp.innerHTML = titleObject['content_' + appConfig.languages[0]];
          if ((temp.textContent && temp.textContent !== 'undefined') || (temp.innerText && temp.innerText !== 'undefined')) {
            title = temp.textContent || temp.innerText;
            return true;
          }
        });
      }
      if (!title) {
        Object.keys(titleObject).some(key => {
          if (key !== 'id') {
            title = titleObject[key];
            return true;
          }
        });
      }
    }
    return title.length > this._limit
      ? title.substr(0, this._limit - 1) + ' &hellip;'
      : title;
  }

  public static getTranslated(object: any, key: string): string {
    let title = '';
    if (object) {
      if (object[key]) {
        return object[key];
      }
      appConfig.languages.some(lang => {
        if (object[key + '_' + lang]) {
          title = object[key + '_' + lang];
          return true;
        }
      });
    }
    return title.length > this._limit
      ? title.substr(0, this._limit - 1) + ' &hellip;'
      : title;
  }
}
